module.exports = __webpack_public_path__ + "img/gatorz-card-custom.338ebdc5.webp";